import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import { Proceso } from 'data/project-management/procesos';
import { NavLink } from 'react-router-dom';

// EXPORT THIS so ProjectListView can import it
export const procesosListTableColumns: ColumnDef<Proceso>[] = [
  {
    accessorKey: 'AUX8',
    header: 'Autos',
    cell: ({ row: { original } }) => {
      const { AUX7, PROC } = original;
      return (
        <NavLink
          to={`/app/apps/project-management/proceso-details/${PROC}`}
          className="text-decoration-none fw-bold fs-8"
        >
          {AUX7}
        </NavLink>
      );
    },
    meta: {
      cellProps: { className: 'py-4' },
      headerProps: { style: { width: '50%', maxWidth: '150px' } }
    }
  },
  {
    accessorKey: 'dias_sin_mto',
    header: 'DÍAS SIN MOV.',
    cell: ({ row: { original } }) => {
      const days = original.dias_sin_mto ?? 0;
      const isOverdue = days > 90;
      return (
        <p className={`fw-bold fs-8 ${isOverdue ? 'text-danger' : ''}`}>
          {days} días
        </p>
      );
    },
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '10%' } }
    }
  },
  {
    accessorKey: 'MIEM', // This is the column we will filter out later
    header: 'Responsable',
    cell: ({ row: { original } }) => (
      <p className="text-decoration-none fw-bold fs-8">{original.MIEM || ''}</p>
    ),
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '8%' } }
    }
  },
  {
    accessorKey: 'expte',
    header: 'EXPTE',
    cell: ({ row: { original } }) => (
      <p className="text-decoration-none fw-bold fs-8">{original.EXP1}</p>
    ),
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '8%' } }
    }
  }
];

const ProcesosListTable = () => {
  return (
    <div className="border-bottom border-translucent">
      <AdvanceTable
        tableProps={{
          className: 'phoenix-table border-top border-translucent fs-9 table-responsive',
          style: { tableLayout: 'fixed', width: '100%' } 
        }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default ProcesosListTable;